import { Observable } from 'rxjs';
import { Component, OnInit, OnChanges, Input } from '@angular/core';

import { SurveyInstance } from 'app/shared/models/survey/survey-instance';
import { TransactionProfileDescService } from './transaction-profile-desc.service';

import { EntityType, EntityIdDetails } from 'app/shared/models/entity-id-details.model';
import {SurveyDetailsComponent} from 'app/entities/surveys/surveyDetails/survey-details.component';

@Component({
    selector: 'transaction-profile-desc',
    providers: [TransactionProfileDescService],
    templateUrl: './transaction-profile-desc.component.html',
    styleUrls: ['./transaction-profile-desc.component.css']
})

/**
 * Component to display the Transaction Profile Description for the entity.
 */
export class TransactionProfileDescComponent implements OnInit, OnChanges {
    @Input() entityIdDetails: EntityIdDetails;
    transactionProfileDetails: SurveyInstance[];
    transactionProfileDescLoaded = false;
    hideSurvey = false;

    constructor(
        private transactionProfileDescService: TransactionProfileDescService) { }

    ngOnInit() {
        this.ngOnChanges();
    }

    ngOnChanges() {
        if (this.entityIdDetails && this.entityIdDetails.entityId) {
            this.getTransactionProfileDesc();
        }
    }

    // Get Transaction Profile Details.
    getTransactionProfileDesc() {
        this.transactionProfileDescLoaded = true;
        this.transactionProfileDescService.getTransactionProfileDesc(this.entityIdDetails.entityId)
        .subscribe(response => {
            if(response.questions.length>0){
            this.transactionProfileDetails = response;
            this.hideSurvey=true;
            }
            this.transactionProfileDescLoaded = false;
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/entities/transaction-profile/transactionprofiledesc/transaction-profile-desc.component.ts